<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="forwarders"
        dense
        @click:row="onClickRow"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col cols="12" sm="12" md="8" lg="8">
                <v-text-field
                  flat
                  dense
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="$rbac.can('setting-forwarder.export')"
                      color="success"
                      v-on="on"
                      small
                      @click="exportExcel"
                      class="m-4"
                    >
                      <v-icon>
                        mdi-file-excel
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Export Excel</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ forwarders.findIndex(x => x === item) + 1 }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" persistent max-width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Form Forwarder</span>
          </v-card-title>
          <v-card-text>
            <form-forwarder :form="item"></form-forwarder>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="close" class="mr-2">
              Close
            </v-btn>
            <v-btn v-if="$rbac.can('setting-forwarder.create')" color="primary" @click="save">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import fileDownload from "js-file-download";
import FormForwarder from "./FormForwarder.vue";

export default {
  name: "forwarder",
  components: {
    FormForwarder,
  },
  data: () => ({
    search: "",
    item: {},
    dialog: false,
    forwarders: [],
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Forwarder Name",
        value: "name",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Description",
        value: "description",
        sortable: false,
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Contact",
        value: "contact",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "NPWP",
        value: "npwp",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("external/getForwarders")
        .then(response => {
          this.forwarders = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onClickRow(item) {
      this.item = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("external/updateForwarder", this.item)
        .then(() => {
          this.initialize();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async exportExcel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("external/exportForwarder")
        .then(response => {
          fileDownload(response.data, "forwarders.xlsx");
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style></style>
